import React from "react";
import "./CheckoutItem.scss"
import placeholder from "../../../assets/collections/empty.jpg"

const CheckoutItem = ({ item }) => {
    return (
        <div className="CheckoutItem">
            <div className="CheckoutItem-left">
                <div className="item-image" >
                    <img alt="" src={item.ProductImage ?? placeholder} />
                </div>
                <div className="item-deatils-container">
                    <div className="item-name">
                        {item.ProductName}
                    </div>
                    <div className="item-dec">
                        Qty :   {item.ProductQty}
                    </div>
                </div>
            </div>
            <div className="CheckoutItem-right">
                <div className="item-price">
                    £{item.ProductPrice}
                </div>
            </div>
        </div>
    )

}
export default CheckoutItem